import * as Yup from "yup";

// export const NATIONALITY = {
//   DOMESTIC: "domestic",
//   FOREIGNER: "foreigner",
// };

export const initialValues = {
    leaveCategory: null,
    leaveDay: null,
    leaveHour: null,
};

// const EmployeeCreateSchema = Yup.object().shape({
//   employeeNationality: Yup.string(),
//   taxId: Yup.string().when("employeeNationality", {
//     is: (val) => val === NATIONALITY.DOMESTIC,
//     then: () =>
//       Yup.string().required(
//         "Please enter your employee identification no. / tax id."
//       ),
//     otherwise: () => Yup.string().notRequired(),
//   }),
//   employeeTypeId: Yup.string().required("Please select your employee type."),
//   titleId: Yup.string().required("Please select your employee title."),
//   nameEn: Yup.string().required("Please enter your employee name."),
//   surName: Yup.string().required("Please enter your employee surname."),
//   departmentId: Yup.string().required(
//     "Please select your employee department."
//   ),
//   positionId: Yup.string().required("Please select your employee position."),
//   email: Yup.string()
//     .email("Invalid email")
//     .required("Please enter your email"),
// });

// export default EmployeeCreateSchema;

const LeaveBenefitSchema = Yup.object().shape({
    leaveTypeName: Yup.string().required("Please select leave type"),
    totalLeaveDays: Yup.string().required("Please enter total leave days"),
    totalLeaveHour: Yup.string().required("Please enter total leave hours")
});
export default LeaveBenefitSchema;